// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#employeeCreditModal{--custom-gray: #3b4372}.employee-credit-container .employee-credit-number{padding-top:2.3rem}\n", "",{"version":3,"sources":["/app/src/component/specific/profile/employeeCredit/employeeCredit.scss"],"names":[],"mappings":"AAAA,qBACE,sBAAc,CACf,mDAIG,kBAAmB","file":"employeeCredit.scss","sourcesContent":["#employeeCreditModal {\n  --custom-gray: #3b4372;\n}\n\n.employee-credit-container {\n  .employee-credit-number {\n    padding-top: 2.3rem;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
